import { Box, Button, TextField, Typography } from '@mui/material';
import React from 'react';

const NodeOperator = () => {
    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    Wanna Become A <span style={{ fontWeight: 700, color: '#433ED1' }}>Node Operator</span>
                </Typography>
            </Box>

            <Box sx={{ pt: '10px', pb: { xs: '20px', md: '28px' } }}>
                <Box sx={{ background: '#EEEFFF', width: { xs: '344px', sm: '635px', md: '860px', lg: '1158px', xl: '80%' }, height: { xs: '161px', sm: '230px', md: '360px', lg: '497px' }, mx: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Box>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'center', pb: { xs: '5px', sm: '10px', lg: '13px' } }}>
                            Video
                        </Typography>
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#A4A4A4', textAlign: 'center', pt: { xs: '5px', sm: '10px', lg: '13px' } }}>
                            exp about device
                        </Typography>
                    </Box>
                </Box>

                {/* submit form */}
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '16px', sm: '20px', md: '22px', lg: '25px' }, lineHeight: { xs: '24px', sm: '28px', lg: '37px' }, color: '#1B1B1B', textAlign: 'left', width: { xs: '344px', sm: '635px', md: '860px', lg: '1158px', xl: '80%' }, mx: 'auto', mt: { xs: '20px', sm: '25px', lg: '40px' }, mb: '10px' }}>Join Us Now !</Typography>
                <Box sx={{ background: '#EEEFFF', width: { xs: '344px', sm: '635px', md: '860px', lg: '1158px', xl: '80%' }, mx: 'auto' }}>
                    <form>
                        <Box sx={{ display: { sm: 'flex' }, justifyContent: 'space-between', alignItems: 'center', p: { xs: '16px', md: '25px', lg: '40px' } }}>
                            <TextField
                                id="outlined-basic"
                                sx={{ width: { xs: '100%', sm: '240px', md: '290px', lg: '372px' }, mb: { xs: '10px', sm: 0 }, background: '#FFFFFF' }}
                                type="text"
                                placeholder="Name"
                                required
                            />
                            <TextField
                                id="outlined-basic"
                                sx={{ width: { xs: '100%', sm: '240px', md: '290px', lg: '372px' }, my: { xs: '10px', sm: 0 }, background: '#FFFFFF' }}
                                type="email"
                                placeholder="Email Id"
                                required
                            />
                            <Button sx={{ textDecoration: 'none', fontSize: { xs: '14px', lg: '16px' }, lineHeight: '20px', color: "#FFFFFF", px: { xs: '22px', sm: '18px', md: '22px' }, py: '12px', backgroundImage: 'linear-gradient(90deg, #312CC2 1.7%, #4D52E6 47.74%, #5868FE 100%)', fontWeight: 600, borderRadius: '1px', mt: { xs: '10px', sm: 0 } }} style={{ textTransform: 'capitalize' }} type='submit'>
                                Submit
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Box>
        </div>
    );
};

export default NodeOperator;